let $place = $('.vacancies__place');

$place.on('click', (e) => {
	let $target = $(e.currentTarget).closest('.vacancies__job');
	let $description = $target.find('.vacancies__description');

	$target.toggleClass('is-active');
	$description.slideToggle(200);
});
